export const I18N = {
    de: {
        searchFieldLabel: 'Suche',
        unfold: 'Aufklappen',
        fold: 'Zuklappen',
        add: 'Hinzufügen',
        edit: 'Bearbeiten',
        showDetails: 'Details anzeigen',
        noAccess: 'kein Zugriff'
    },
    en: {
        searchFieldLabel: 'Search',
        unfold: 'Open',
        fold: 'Close',
        add: 'Add',
        edit: 'Edit',
        showDetails: 'Show details',
        noAccess: 'No access'
    }
};
